import React, { useState, useEffect } from 'react';
import { Table, Button, message, Modal } from 'antd';
import axios from 'axios';
import config from '../config';

const TemplatesPage = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.apiSettings.root}wp-ai-workflows/v1/templates`, {
        headers: { 'X-WP-Nonce': config.apiSettings.nonce }
      });
      setTemplates(response.data);
    } catch (error) {
      console.error('Error fetching templates:', error);
      message.error('Failed to fetch templates');
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${config.apiSettings.root}wp-ai-workflows/v1/templates/${id}`, {
        headers: { 'X-WP-Nonce': config.apiSettings.nonce }
      });
      message.success('Template deleted successfully');
      fetchTemplates();
    } catch (error) {
      console.error('Error deleting template:', error);
      message.error('Failed to delete template');
    }
  };

  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    { title: 'Created At', dataIndex: 'created_at', key: 'created_at' },
    { title: 'Updated At', dataIndex: 'updated_at', key: 'updated_at' },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button onClick={() => handleDelete(record.id)} danger>Delete</Button>
      ),
    },
  ];

  return (
    <div>
      <h1>Templates</h1>
      <Table columns={columns} dataSource={templates} rowKey="id" loading={loading} />
    </div>
  );
};

export default TemplatesPage;